export default async ({ app }) => {
  // const isDarkTheme = (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)
  // const theme = isDarkTheme ? 'theme-dark' : 'theme-light'
  const theme = 'theme-dark'
  document.body.className = theme
  await app.store.dispatch('base/act_setTheme', { theme })
}
